import CountUp from 'react-countup'

export const NumberCountUp = ({ value }: { value: number }) => (
  <CountUp preserveValue start={0} end={value} delay={0}>
    {({ countUpRef }) => <span ref={countUpRef} />}
  </CountUp>
)
